import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import eldRatings from "../../../../src/data/articles/cube-prospective-throne-of-eldraine/eld-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  eldRatings,
  ProspectiveIntro,
  React
};